import api_agents from '../api/agents'
import api_base from '../api/api'


// initial state
const state = {
  role: undefined,
  alerts: [],
  list_state: 'loading',
};

// getters
// noinspection JSUnusedGlobalSymbols
const getters = {
  api: (state) => {
    if (state.role === 'agent') return api_agents;
    if (state.role === 'user') return api_base;
    return {};
  },
  isHaveJustReceivedAlerts: (state, getters) => {
    return getters.justReceivedAlerts.length > 0
  },
  justReceivedAlerts: state => {
    return _.filter(state.alerts, alert => {
        return alert.attributes.just_received
      }
    )
  },
  allAlerts: state => {
    return _.orderBy(state.alerts, ['attributes.created_at'],['desc'])
  },
  newAlerts: state => {
    // return _.filter(state.alerts, ['attributes.state', 'new'])
    return _.filter(state.alerts, alert => {
        return alert.attributes.state === 'new'
      }
    )
  },
};

// actions
// noinspection JSUnusedGlobalSymbols
const actions = {
  getAlerts({dispatch, commit, getters}, payload) {
    console.log('ACTION - getAlerts :', payload);
    commit('setListState', 'loading');
    return getters.api.getAlerts(payload, data => {
      commit('setAlerts', data.data);
      commit('setListState', 'stored');
    })
  },

  addAlert({dispatch, commit, getters}, payload) {
    console.log('ACTION - addAlert :', payload);
    commit('addAlert', payload);
  },

  removeAlert({dispatch, commit, getters}, payload) {
    console.log('ACTION - removeAlert :', payload);
    return getters.api.destroyAlert(payload, data => {
      commit('removeAlert', data.data);
    })
  },

  resetJustReceivedAlert({dispatch, commit, getters}, payload) {
    console.log('ACTION - resetJustReceivedAlert :', payload);
    _.each(getters.justReceivedAlerts, alert => {
      commit('moveToPanel', alert);
    })
  },
};

// mutations
// noinspection JSUnusedGlobalSymbols
const mutations = {
  setListRole(state, role){
    state.role = role;
  },

  setAlerts (state, alerts) {
    state.alerts = alerts;
  },

  setListState (state, list_status) {
    state.list_state = list_status;
  },

  addAlert (state, alert) {
    let i = _.findIndex(state.alerts, ['id', alert.id]);
    console.log('+++ ADD alert', i, alert);
    if (i === -1) state.alerts.push(alert);
  },

  moveToPanel (state, alert) {
    let index = _.findIndex(state.alerts, {id: alert.id});
    if (index > -1) {
      alert.attributes = Object.assign(alert.attributes, {just_received: false});
      state.alerts.splice(index, 1, alert);
    } else {
      //обработка ошибок
      console.error('Элемент не найден - ID:', alert.id);
    }
  },

  removeAlert (state, alert) {
    let index = _.findIndex(state.alerts, {id: alert.id});
    if (index > -1) {
      state.alerts.splice(index, 1);
    } else {
      //обработка ошибок
      console.error('Элемент не найден - ID:', alert.id);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
